<template>
  <div class="ticket-detail">
    <el-dialog :title="$t('customerService.ticket_details')" :visible.sync="dialogTableVisible" width="580px" class="diglog-card" @open="getDetailInfo">
      <div class="item" style="margin:0">
        <span class="item-left content-blue">{{ $t('customerService.business_type') }}</span>
        <span class="content-gray">{{ getBusinessTypeLabel(ticketInfo.operation_type) }}</span>
      </div>

      <!-- <div v-if="ticketInfo.operation_type === 1" class="item">
        <span class="item-left content-blue">{{ $t('customerService.payment_method') }}</span>
        <span class="content-gray">  {{ getTicketPaymentMethodMap(ticketInfo.payment_method) }}</span>
      </div>
      <div v-if="ticketInfo.qr_link" class="item">
        <span class="item-left content-blue">QR Link</span>
        <span class="content-gray">  {{ ticketInfo.qr_link }}</span>
      </div>
      <div v-if="ticketInfo.qrcode" class="item">
        <span class="item-left content-blue">QR Code ID</span>
        <span class="content-gray">   {{ ticketInfo.qrcode }}</span>
      </div> -->

      <div v-if="ticketInfo.merchant_order_id" class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">  {{ ticketInfo.merchant_order_id }}</span>
      </div>

      <div v-if="ticketInfo.refund_amount" class="item">
        <span class="item-left content-blue">{{ $t('customerService.request_refund_amount') }}</span>
        <span class="content-gray">  {{ ticketInfo.refund_amount | toDivideWithDot }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('dashboard.transaction_amount') }}</span>
        <span class="content-gray"> {{ ticketInfo.amount | toDivideWithDot }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">  {{ $t('components.transaction_date') }}</span>
        <span class="content-gray">  {{ ticketInfo.transaction_date }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">  {{ $t('customerService.customer_phone_number') }}</span>
        <span class="content-gray">  {{ ticketInfo.phone_no | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="section-title  mb-12 mt-24">
        {{ $t('customerService.other_details') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.description') }}</span>
        <span class="content-gray">{{ ticketInfo.issue }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">
          {{ $t('customerService.attachments') }}</span>
        <span v-for="fileName in ticketInfo.attachmentsList" :key="fileName" class="content-file" @click="onClickFileName(fileName)">{{ fileName }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue"> {{ $t('customerService.payment_receipt') }}</span>
        <img v-if="ticketInfo.pic_path" v-viewer :src="ticketInfo.pic_path" class="content-img">
      </div>

      <div class="item">
        <span class="item-left content-blue">
          {{ $t('customerService.conclusion') }}
        </span>
        <span class="content-gray">{{ ticketInfo.conclusion }}</span>
      </div>

      <!-- <div class="section-title">
        {{ $t('customerService.replies') }}
      </div>
      <div class="line-bottom-1px" style="margin-bottom: 24px" /> -->

      <!-- <div class="reply-container">
        <template v-for="item in ticketInfo.issue_reply_list" >
        <div class="reply-item" v-if="item.content" :key="item.create_time">
          <div class="reply-top">
            <span class="reply-name">{{item.edit_name}}</span>
            <span class="reply-tag-customer-service" v-if="item.type ===1">Customer Service</span>
            <span class="reply-tag-merchant" v-if="item.type ===2">Merchant</span>
            <span class="reply-time">{{ item.create_time }}</span>
          </div>
          <p class="reply-content">{{  item.content  }}</p>
          <template v-if="item.replay_file_list">
            <div v-for="fileName in item.fileNameArr" :key="fileName">
              <img v-if="isImg(fileName)" class="content-img reply-content-img" v-viewer :src="item.replay_file_list[fileName]" alt="">
              <div v-else class="reply-content-file" @click="onClickIcon(fileName,item.replay_file_list[fileName] )">{{ fileName }}</div>
            </div>
          </template>
        </div>
      </template>
      </div> -->

      <el-tag :type="getTicketStatusStyle(ticketInfo.status)" class="tag-custom payin-status"> {{ getTicketStatusLabel(ticketInfo.status) }}</el-tag>
      <div class="btn-container" />
    </el-dialog>
    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { ticketDetail } from '@/api/customer-service/customer-service'
import { csTicketStatusMap, ticketPaymentMethodMap, merchantProductMap } from '@/utils/maps'
import { download } from '@/utils/common'
export default {
  name: 'Ticket_Details_Modal',
  props: {
    detailId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogImageVisible: false,
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      ticketInfo: { }
    }
  },
  computed: {
    getTicketPaymentMethodMap() {
      return function(value) {
        return ticketPaymentMethodMap(value).label
      }
    },
    getBusinessTypeLabel() {
      return function(value) {
        return merchantProductMap(value).label
      }
    },
    getTicketStatusLabel() {
      return function(value) {
        return csTicketStatusMap(value).label
      }
    },
    getTicketStatusStyle() {
      return function(value) {
        return csTicketStatusMap(value).type
      }
    },
    isImg() {
      return function(value) {
        return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(value)
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      ticketDetail({ id: this.detailId }).then(res => {
        const { data } = res
        const { file_paths = {}, issue_reply_list = [] } = data
        const issueList = issue_reply_list.map(item => {
          const fileNameArr = []
          if (!item.replay_file_list) {
            return item
          }
          const nameList = Object.keys(item.replay_file_list)
          nameList.forEach(nItem => {
            if (this.isImg(nItem)) {
              fileNameArr.push(nItem)
            } else {
              fileNameArr.unshift(nItem)
            }
          })
          item.fileNameArr = fileNameArr
          return item
        })
        data.issue_reply_list = issueList
        this.ticketInfo = data
        this.ticketInfo.attachmentsList = Object.keys(file_paths)
      })
    },
    changModalStatus(value) {
      this.dialogTableVisible = value
    },
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url
      this.dialogImageVisible = true
    },
    onClickFileName(fileName) {
      const fileUrl = this.ticketInfo.file_paths[fileName]
      download(fileUrl)
    },
    onClickIcon(fileName, url) {
      if (!/\.(pdf|PDF)$/.test(fileName)) {
        const url = encodeURIComponent(fileUrl)
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + url,
          '_blank'
        )
        return
      } else {
        window.open(fileUrl, '_blank')
      }
    }
  }
}
</script>

<style>
.ticket-detail .el-dialog__title {
  font-weight: 500;  font-family: 'Poppins-Medium';
  font-size: 16px;
  color: #000000;
}
.ticket-detail .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>

<style scoped lang="scss">
.btn-container{
  margin-top: 32px;
  display: flex;
  .btn-download,.btn-retry{
    flex: 1;
  }
  .btn-retry{
    margin-left: 24px;
  }
}
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Poppins-SemiBold';
    line-height: 1.2;
    color: #488CE8;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #364250;
}
.content-gray{
  flex: 1;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #488CE8;
}
.content-img{
  cursor: pointer;
  height: 100px;
  max-width: 300px;
}
.content-file{
  color:#488CE8;
  text-decoration: underline;
  cursor: pointer;
}

.ticket-detail{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 12px;
    left: 160px;
  }
}
.reply-container{
    padding-right: 15px;
    &::-webkit-scrollbar-track-piece {
      background: #d3dce6;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #99a9bf;
      border-radius: 20px;
    }
  max-height: 400px;
  overflow: auto;
}
.reply-item{
  margin-bottom: 16px;
  padding: 21px 28px;
  border-radius: 10px;
  border: 1px solid #D3D7DF;
}
.reply-top{
  display: flex;
  align-items: center;
}
.reply-name{
  font-weight: 500;
  font-size: 14px;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.reply-tag-customer-service{
  margin: 0 16px;
  padding: 2px 8px;
  background: #34C759;
  border-radius: 12px;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
}
.reply-tag-merchant{
  margin: 0 16px;
  padding: 2px 8px;
  background: #488CE8;
  border-radius: 12px;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
}
.reply-time{
  font-weight: 400;
  font-size: 12px;
  color: #A0A5AD;
}
.reply-content{
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5;
  color: #4B5567;
}

.reply-content-img{
  margin-bottom: 10px;
}
.reply-content-file{
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: #488CE8;
}

</style>

